import {
  ACTIVITIES_CONTENT_STATUS_PUBLISHED,
  ActivitiesContentStatus,
} from 'global/constants';

export function hasPublishedActivities(
  activities: { status: ActivitiesContentStatus }[] | undefined | null
) {
  return activities?.[0]?.status === ACTIVITIES_CONTENT_STATUS_PUBLISHED;
}
